const components = {
  DsfAuditState: dsf.defineAsyncComponent("DsfAuditState", () =>
    import(/*webpackChunkName:"platform_pc_form"*/ "./auditState.vue")
  ),
  DsfAuditStateListForm: dsf.defineAsyncComponent("DsfAuditStateListForm", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_state"*/ "./auditStateForm.vue"
    )
  ),
};

function install(Vue) {
  for (let key in components) {
    let it = components[key];
    let name = dsf.isFunction(it) ? it.ctrlName || key : it.name;
    Vue.component(name, it);
    if (!window.$components["platform"]) {
      window.$components["platform"] = {};
    }
    window.$components["platform"][name] = it;
  }
}

export { install };
export default install;
